import {
  LayoutDashboard,
  BookOpen,
  GraduationCap,
  TrendingUp,
  BarChart3,
  Trophy,
  Heart,
  User,
  CreditCard,
  Receipt,
  UserPlus,
  Bell,
  Settings,
  HelpCircle,
  LifeBuoy,
  MessageSquare,
  Crown,
  Briefcase,
  type LucideIcon,
} from "lucide-react";

export interface SidebarItemConfig {
  to: string;
  icon: LucideIcon;
  labelKey: string;
  end?: boolean;
}

export interface SidebarSectionConfig {
  labelKey: string;
  items: SidebarItemConfig[];
}

const baseUserSections: SidebarSectionConfig[] = [
  {
    labelKey: "sidebar.sections.learning",
    items: [
      { to: "/dashboard", icon: LayoutDashboard, labelKey: "sidebar.user.dashboard", end: true },
      { to: "/my-courses", icon: BookOpen, labelKey: "sidebar.user.courses" },
      { to: "/my-bootcamps", icon: GraduationCap, labelKey: "sidebar.user.bootcamps" },
      { to: "/wishlist", icon: Heart, labelKey: "sidebar.user.wishlist" },
      { to: "/my-performance", icon: TrendingUp, labelKey: "sidebar.user.performance" },
      { to: "/my-analytics", icon: BarChart3, labelKey: "sidebar.user.analytics" },
      { to: "/gamification", icon: Trophy, labelKey: "sidebar.user.gamification" },
    ],
  },
  {
    labelKey: "sidebar.sections.prepPremium",
    items: [
      { to: "/prep/dashboard", icon: Crown, labelKey: "sidebar.user.prepPremium" },
      { to: "/prep/contests", icon: BookOpen, labelKey: "sidebar.user.prepContests" },
      { to: "/prep/interviews", icon: Briefcase, labelKey: "sidebar.user.prepInterviews" },
      { to: "/prep/study-plan", icon: TrendingUp, labelKey: "sidebar.user.prepStudyPlan" },
    ],
  },
  {
    labelKey: "sidebar.sections.account",
    items: [
      { to: "/profile", icon: User, labelKey: "sidebar.user.profile" },
      { to: "/subscription-management", icon: CreditCard, labelKey: "sidebar.user.subscription" },
      { to: "/payment-history", icon: Receipt, labelKey: "sidebar.user.payments" },
      { to: "/invitations", icon: UserPlus, labelKey: "sidebar.user.invitations" },
      { to: "/announcements", icon: Bell, labelKey: "sidebar.user.announcements" },
      { to: "/messages", icon: MessageSquare, labelKey: "sidebar.user.messages" },
    ],
  },
  {
    labelKey: "sidebar.sections.support",
    items: [
      { to: "/settings", icon: Settings, labelKey: "sidebar.user.settings" },
      { to: "/support", icon: LifeBuoy, labelKey: "sidebar.user.support" },
      { to: "/faq", icon: HelpCircle, labelKey: "sidebar.user.faq" },
    ],
  },
];

/**
 * Returns the personal sections every authenticated user always sees
 * (Learning, Account, Support). Admin / instructor sections are merged
 * separately by DashboardShell when those roles are present.
 *
 * `isAdmin` is accepted for API compatibility but no longer prepends a
 * mini Control Center — the full admin sidebar is merged in instead.
 */
export function buildUserSidebar(_opts?: { isAdmin?: boolean }): SidebarSectionConfig[] {
  return baseUserSections;
}

/** Backward-compatible export — student-only view. Prefer `buildUserSidebar` in shells. */
export const userSidebarConfig: SidebarSectionConfig[] = baseUserSections;
